import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MessageService } from 'primeng/components/common/messageservice';

import { environment } from '../../../environments/environment';
import { BaseService } from '../base/util/base.service';
import {
  cancelarGTO,
  configsTokenGto,
  excluirItem,
  finalizarGTO,
  imprimirGTO,
  prorrogarGTO,
  salvarGTO,
  salvarProcedimentos,
} from '../base/util/url-util';
import { CancelaGTO } from '../base/vo/cancela-gto';
import { FinalizaGTO } from '../base/vo/finaliza-gto';
import { Gto } from '../base/vo/gto';
import { ProcedimentoCancela } from '../base/vo/procedimentoCancela';
import { SalvarDataDeRealizacaoDTO } from '../base/vo/salva-procedimento';


@Injectable()
export class AcoesService extends BaseService {
  private canGoToFinalizar = false;
  private header = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

  constructor(public http: HttpClient, public messageService: MessageService) {
    super(http, messageService);
  }

  prorrogaGTO(numeroGTO: string) {
    return this.get(prorrogarGTO(numeroGTO));
  }

  cancelaGTO(cancelaGTO: CancelaGTO) {
    return this.post(cancelarGTO(cancelaGTO.numero),
      JSON.stringify(cancelaGTO));
  }

  imprimirGTO(numeroGTO: string) {
    return this.get(imprimirGTO(numeroGTO));
  }

  finalizaGTO(finalizaGTO: FinalizaGTO) {
    return this.post(finalizarGTO(finalizaGTO.numero),
      JSON.stringify(finalizaGTO));
  }

  excluirProcedimento(procedimentoCancela: ProcedimentoCancela) {
    return this.http.post(
      excluirItem(
        procedimentoCancela.numero), JSON.stringify(procedimentoCancela), { headers: this.header })
      .map((response: Response) => {

        return response;
      });
  }

  dadosGto(idGto: string) {
    const url = `${environment.urlApi}gto/${idGto}`;

    return this.get(url);
  }

  salvarGTO(gto: Gto) {
    return this.post(
      salvarGTO, JSON.stringify(gto), this.header)
      .map((response: Response) => {
        return response;
      });
  }

  salvarProcedimentos(numeroGto: string, salvarDataDeRealizacaoDTO: SalvarDataDeRealizacaoDTO) {
    return this.http.post(
      salvarProcedimentos(numeroGto),
      JSON.stringify(salvarDataDeRealizacaoDTO),
      { headers: this.header }
    ).map((response: Response) => {
      return response;
    });
  }

  buscarConfigsToken() {
    return this.get(configsTokenGto());
  }

  getCanGoToFinalizar() {
    return this.canGoToFinalizar;
  }

  setCanGoToFinalizar(canGoToFinalizar: boolean) {
    this.canGoToFinalizar = canGoToFinalizar;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/acoes/acoes.service.ts